
export default function AssetsTableHeadCell({ children }) {
    return (
        <th className="px-3 py-3 text-left text-sm font-bold text-black break-words">
            {children}
        </th>
    );
}